'use client';

import { useState } from 'react';


interface FAQ {
  question: string;
  answer: string;
}

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs: FAQ[] = [
  {
    question: 'Jak dlouho trvá průměrné partnerství?',
    answer: 'Průměrná délka našeho partnerství je 3.2 roku, ale máme klienty, kteří s námi spolupracují i 5+ let. Partnerství není časově omezené - pokračuje tak dlouho, jak je pro vás přínosné. Můžete ho kdykoliv ukončit s měsíční výpovědní lhůtou.'
  },
  {
    question: 'Co když se moje situace výrazně změní?',
    answer: 'To je přesně důvod, proč existuje dlouhodobé partnerství. Když se změní vaše zaměstnání, přijde dítě, koupíte nemovitost nebo se stane cokoliv jiného, váš plán se okamžitě přizpůsobí. Kontaktujete nás, probereme změnu a upravíme strategii. To je součástí služby, neplatíte za to extra.'
  },
  {
    question: 'Musím se účastnit všech čtvrtletních schůzek?',
    answer: 'Čtvrtletní revize jsou doporučené, protože zajišťují, že váš plán zůstává aktuální. Ale rozumíme, že život je náročný. Pokud nemůžete na osobní schůzku, můžeme ji udělat online nebo ji přesunout. Důležité je, aby revize proběhla, forma je flexibilní.'
  },
  {
    question: 'Jak rychle dostanu odpověď na dotaz?',
    answer: 'Na emaily odpovídáme do 24 hodin v pracovní dny. Na naléhavé situace reagujeme rychleji - často do několika hodin. Klienti s Pokročilým a Prémiovým partnerstvím mají prioritní podporu a přímé telefonní číslo pro urgentní záležitosti.'
  },
  {
    question: 'Co když budu chtít partnerství ukončit?',
    answer: 'Partnerství můžete ukončit kdykoliv s měsíční výpovědní lhůtou. Žádné sankce, žádné skryté poplatky. Pokud odcházíte, předáme vám kompletní dokumentaci a váš aktuální finanční plán. Chceme, abyste s námi byli, protože vidíte hodnotu, ne kvůli smluvním závazkům.'
  },
  {
    question: 'Dostanu přístup k finančnímu poradci kdykoliv?',
    answer: 'Ano, ale forma závisí na úrovni partnerství. Základní partnerství zahrnuje email a telefon v pracovní době. Pokročilé přidává prioritní komunikaci a WhatsApp. Prémiové nabízí téměř neomezenou dostupnost včetně víkendů pro urgentní situace.'
  },
  {
    question: 'Jak funguje klientský portál?',
    answer: 'Portál je vaše osobní finanční centrum. Vidíte tam aktuální verzi plánu, historii změn, dokumenty, pokrok k cílům a můžete komunikovat s vaším poradcem. Je dostupný 24/7 z počítače i mobilu. Po zahájení partnerství dostanete přihlašovací údaje a provedeme vás funkcemi.'
  },
  {
    question: 'Co když potřebuji pomoc mimo finanční plánování?',
    answer: 'Často spolupracujeme s dalšími odborníky - daňoví poradci, právníci, účetní. Pokud vaše situace vyžaduje specializovanou pomoc, doporučíme vám ověřené profesionály a můžeme koordinovat spolupráci. U Prémiového partnerství je tato koordinace součástí služby.'
  }];


  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return;

































































};

export default FAQSection;